// Keep in sync with Sammandrag.Web/Model/EventVisibility.cs
export enum EventVisibility {
    Private = 0,
    Public = 1,
}
